import { takeEvery, all, put } from '@redux-saga/core/effects';
import { USER_FOUND } from 'redux-oidc';
import { accountVerificationActions } from '../actions/accountVerification/accountVerification';



export function* fetchAccountVerificationStatus() {
  yield put(accountVerificationActions.fetchStatus());
}

export function* watchAuth() {
  yield all([
    takeEvery(USER_FOUND, fetchAccountVerificationStatus)
  ]);
}
